import { render, staticRenderFns } from "./MoveTemplate.vue?vue&type=template&id=2dadda32"
import script from "./MoveTemplate.vue?vue&type=script&lang=js"
export * from "./MoveTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports